import { breakpoints, theme, Typography } from '@notino/react-styleguide';

import { css } from '@linaria/core';

export const noScrollbarCss = `
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ellipsis = `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const ellipsisClass = css`
  ${ellipsis}
`;

export const typographyClass: Typography = {
  titleDisplay: css`
    ${theme.typography.titleDisplay}
  `,
  titleLarge: css`
    ${theme.typography.titleLarge}
  `,
  titleMedium: css`
    ${theme.typography.titleMedium}
  `,
  titleSmall: css`
    ${theme.typography.titleSmall}
  `,
  bodyLarge: css`
    ${theme.typography.bodyLarge}
  `,
  bodyRegular: css`
    ${theme.typography.bodyRegular}
  `,
  bodySmall: css`
    ${theme.typography.bodySmall}
  `,
  labelLarge: css`
    ${theme.typography.labelLarge}
  `,
  labelLarge400: css`
    ${theme.typography.labelLarge400}
  `,
  labelRegular: css`
    ${theme.typography.labelRegular}
  `,
  labelRegular400: css`
    ${theme.typography.labelRegular400}
  `,
  labelSmall: css`
    ${theme.typography.labelSmall}
  `,
  labelSmall400: css`
    ${theme.typography.labelSmall400}
  `,
  labelButton: css`
    ${theme.typography.labelButton}
  `,
};

export const mobileVisibleLg = css`
  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`;

export const desktopVisibleLg = css`
  display: none;
  @media (min-width: ${breakpoints.lg}) {
    display: block;
  }
`;

export const desktopVisibleMd = css`
  display: none;
  @media (min-width: ${breakpoints.md}) {
    display: block;
  }
`;

export const mobileVisibleMd = css`
  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`;

export const desktopVisibleSm = css`
  display: none;
  @media (min-width: ${breakpoints.sm}) {
    display: block;
  }
`;

export const mobileVisibleSm = css`
  @media (min-width: ${breakpoints.sm}) {
    display: none;
  }
`;

export const desktopVisibleXl = css`
  display: none;
  @media (min-width: ${breakpoints.xl}) {
    display: block;
  }
`;

export const mobileVisibleXl = css`
  @media (min-width: ${breakpoints.xl}) {
    display: none;
  }
`;

export const desktopVisibleXxl = css`
  display: none;
  @media (min-width: ${breakpoints.xxl}) {
    display: block;
  }
`;

export const mobileVisibleXxl = css`
  @media (min-width: ${breakpoints.xxl}) {
    display: none;
  }
`;
